import { WALLET_TYPE } from './WalletType';

export const REDEMPTION_METHOD = {
  Bank: "Bank",
  Bitcoin: "Bitcoin",
  Ethereum: "Eth",
  Physical: "Physical",
  ERC20: "Erc20",
  InternalNetwork: "InternalNetwork"
};

export const SCALE = {
  [REDEMPTION_METHOD.Bank]: 2,
  [REDEMPTION_METHOD.Bitcoin]: 8,
  [REDEMPTION_METHOD.Ethereum]: 18,
  [REDEMPTION_METHOD.ERC20]: 18,
  [REDEMPTION_METHOD.InternalNetwork]: 18,
  [REDEMPTION_METHOD.Physical]: 16 // default value
};

export const REDEMPTION_WALLET_TYPE = {
  [REDEMPTION_METHOD.Bitcoin]: WALLET_TYPE.Bitcoin,
  [REDEMPTION_METHOD.Ethereum]: WALLET_TYPE.Ethereum,
  [REDEMPTION_METHOD.ERC20]: WALLET_TYPE.Ethereum,
  [REDEMPTION_METHOD.InternalNetwork]: WALLET_TYPE.InternalNetwork
};
